<template>
  <div class="page-activity">
    <van-icon @click="handleBack" :style="{ transform: 'rotate(-90deg)' }" class="back-home" name="share-o" />
    <van-image
      width="100vh"
      height="auto"
      fit="cover"
      :src="activityImg"
      style="margin-right: -75px;margin-top: 75px;margin-left: -75px;"
      :style="{ transform: 'rotate(90deg)' }"
    />
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { queryClassSelectPage } from "@/api/user";

export default defineComponent({
  name: "ActivityGraphic",

  components: {},

  setup() {

    const route = useRoute();

    const router = useRouter();

    const activityImg = ref(null)

    onMounted(() => {
      getClassSelectPage()
    });

    const getClassSelectPage = async () => {
       try {
        const result = await queryClassSelectPage({
          className: route?.query?.className,
          page: {
            pageIndex: 1,
            pageSize: 10
          }
        });
        console.log(result);
        if (result.code === "00") {
          const list = result?.data.list ?? []
          activityImg.value = list?.[0].classTableImg
        } else {
          activityImg.value = null
        }
      } catch (error) {
        console.log("error:>>>", error);
        activityImg.value = null
      }
    }

    const handleBack = () => {
      router.back()
    }


    return {
      activityImg,
      handleBack
    };
  },
});
</script>

<style lang="scss" scoped>
.page-activity {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
}

.back-home {
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 999;
  font-size: 18px;
}
</style>